module.exports = __webpack_public_path__ + "static/media/F.1fca65b2.png";